import { render } from "./tip.vue?vue&type=template&id=45ff2698&scoped=true&lang=pug"
import script from "./tip.vue?vue&type=script&setup=true&lang=js"
export * from "./tip.vue?vue&type=script&setup=true&lang=js"

import "./tip.vue?vue&type=style&index=0&id=45ff2698&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ff2698"]])

export default __exports__